import React, {useEffect, useState} from 'react';
// MATERIAL UI
import {Grid, } from '@material-ui/core/';
import {Person, HighlightOff } from '@material-ui/icons';
// COMPONENTS
import { useStyles } from "./style";
import Form from 'components/Form/FormTwoColumns';
import ApiServices from 'services/ApiServices';
import {showMessagePersonalizedPosition} from 'services/SweetAlert'
import Title from 'components/TitleWithIcon';
import DialogLoadingMessage from 'components/LoadingMessage/index'

let nroboleta = '', datosPadron = ''
function ComponenteDeFormularioParaHabilitacionDeFallecidos(props) {
    nroboleta = props.nroboleta
    datosPadron = props.datosPadron
    let description = [
        {name: "- Antes de continuar, revise que la información que ingresó esté correcta.",},
        {name: "- Datos requeridos (*)."}
    ];
    const classes = useStyles(),
        [loadingMessage, setLoadingMessage] = useState({loading: false, title:''});

    const AgregarCaptacionDeFallecido= async ()=>{
        if(!datosPadron) return showMessagePersonalizedPosition('warning', '¡Oops! ' , 'Por favor realice una búsqueda para realizar el proceso de habilitación.');
        let saveData = {
            nroboleta: nroboleta,
            estado: elements.estado.value?.id,
            base64: elements.base64.value,
            observacion: elements.observacion.value,
            password: elements.password.value,
        }
        setLoadingMessage({loading: true, title: 'Habilitando fallecido ...'})
        try{
            const response =  await ApiServices.habilitacion.update(saveData)
            if(response.error!==null){
                showMessagePersonalizedPosition('warning', '¡Oops! ' ,response.error.message)
            }else{
                showMessagePersonalizedPosition('success','¡BIEN!', response.data)
                Cancelar();
                props.actualizarTabla()
            }   
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
        }                 
        setLoadingMessage({loading: false, title: ''})
    };
        
    const Cancelar=()=>{
        props.closeModal()
    };    
    
    const [elements,setElements] = useState({
            estado: {
                idelement: "estado", value: null, label: "Seleccione estado *", pattern:"^[1-9][0-9]*$", validators: ['required'],
                errorMessages:['Seleccione estado'], isError:false, elementType:'autocompleteV2', list: [],
            },
            base64:{
                idelement: "base64", value: '', label: "Adjunte documento *",
                validators: {required: true,  size: "2 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'file',
                disabled:false, name:"base64", fileWidth: true, src: '', multiple: false, accept:".pdf",
            },            
            observacion: {
                idelement: "observacion",  value:'', label: "Ingrese observación *", pattern:"^([\\w_ÑñwáéíóúÁÉÍÓÚ.,!¡\"#$%&/()=¿?'@*-][\\w_ ÑñwáéíóúÁÉÍÓÚ.,!¡\"#$%&/()=¿?'@*-]*[\\w_ÑñwáéíóúÁÉÍÓÚ.,!¡\"#$%&/()=¿?'@*-]){2,250}$",
                validators: ['required'], errorMessages:['Ingrese observación, sin espacios al inicio y final'], isError:false, elementType:'textArea',
            },
        firmaElectronica:{
            idelement: "firmaElectronica",title:'Ingrese Firma Electrónica', position:"center", value: "", isError:true, elementType:'titleCustom', validators: ['requireds'],
            show: true,
        },            
            password: { 
                idelement: "password",  value:'', label: 'Ingrese contraseña *', pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", 
                validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' 
            },
    });    
    
    const [buttonList,setButtonList]= React.useState({
        "next":{"label":"Habiliar fallecido","icon": <Person />,"callback":AgregarCaptacionDeFallecido,"loading":loadingMessage.loading, disabled:loadingMessage.loading, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},
        "cancel":{"label":"Cerrar","icon": <HighlightOff />,"callback":Cancelar,"loading":false, disabled:false, isCancel:true, IsButtonCancelar:true},
    });

    const obtenerCatalogoEstadosPadron =async ()=>{
        setLoadingMessage({loading: true, title: 'Cargando catálogo ...'})
        let newElements= Object. assign({}, elements); 
        try{
            let response = await ApiServices.estadospadron.listRegisterCriteria();
            newElements.estado.list=[];
            if(response.error){
                showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
            }else {  
                let newData = []
                for (let index = 0; index < response.data.length; index++) {
                    newData.push({id: response.data[index].codStatus, name: response.data[index].codStatus+'. '+response.data[index].nombreStatus})
                }
                newElements.estado.list = newData
            } 
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Oops! ' ,"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }
            else {
                showMessagePersonalizedPosition('error', '¡Oops! ' ,"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
            }                    
        }
        setElements(newElements);
        setLoadingMessage({loading: false, title: ''})
    };

    useEffect(() => {
        obtenerCatalogoEstadosPadron()
    }, [])
    return (
        <div id="scroller" className={classes.root}>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <div className={classes.colorComponente}>
                <Grid container >
                    <Title title="COMPLETE LA INFORMACIÓN" icon={""}/>                
                    <Grid className={classes.AlignTable} item xs={12} direction="row" justify="center" alignItems="center"> <br/>
                        <Form   elements= {elements}  buttonList={buttonList} description={description}
                        />
                    </Grid>           
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div><br/>
        </div>
    );
}
export default ComponenteDeFormularioParaHabilitacionDeFallecidos;